import { Users } from "lucide-react";
import type { LineageNode } from "../types";
import { NodeShell } from "./NodeShell";

interface Props {
  data: LineageNode;
  selected?: boolean;
}

export function CandidateAssessmentsAggregateNode({ data, selected }: Props) {
  const agg = data.aggregate;
  const footer = agg ? (
    <div className="space-y-1">
      <div>
        {agg.fresh} fresh ·{" "}
        <span className={agg.stale > 0 ? "text-red-600" : ""}>{agg.stale} stale</span>
      </div>
      {agg.byBlueprintVersion.length > 0 && (
        <div className="text-text-muted">
          {agg.byBlueprintVersion
            .map((b) => `${b.versionNumber !== null ? `v${b.versionNumber}` : "—"}: ${b.count}`)
            .join(" · ")}
        </div>
      )}
    </div>
  ) : null;

  return (
    <NodeShell
      node={data}
      icon={Users}
      selected={selected}
      showVersionChip={false}
      footer={footer}
    />
  );
}
